import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SharedModule } from './submodules/shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { CookieService } from 'ngx-cookie-service';

import fr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { FertilityDashboardModule } from './submodules/fertility-dashboard/fertility-dashboard.module';
import { HomeDashboardComponent } from './pages/home-dashboard/home-dashboard.component';
import { MecsDashboardModule } from './submodules/mecs-dashboard/mecs-dashboard.module';

registerLocaleData(fr);

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
    AccessDeniedComponent,
    HomeDashboardComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    FertilityDashboardModule,
    MecsDashboardModule
  ],
  providers: [
    CookieService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
